export default __webpack_public_path__ + "static/favicon-daca80d2bb7fb5c576685415aba22856.ico";